module.exports = __webpack_public_path__ + "img/logo1.df8f4b52.png";